import { useKestrelViewerContext } from 'features/kestrelViewer'
import { ThermalGradientPanel as ThermalGradientPanelContent } from 'features/kestrelViewer/ui/tools/viewControls/ThermalGradientPanel'
import React from 'react'
import styled from 'styled-components'

const ThermalPanelOverlay = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 50px;
  right: 120px;
  width: 450px;
  z-index: 500;
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
  pointer-events: auto;
`

export const ThermalGradientPanel: React.FC = () => {
  const { thermalGradientVisible } = useKestrelViewerContext()

  return thermalGradientVisible ? (
    <ThermalPanelOverlay $isVisible={thermalGradientVisible}>
      <ThermalGradientPanelContent />
    </ThermalPanelOverlay>
  ) : null
}
